import { render, staticRenderFns } from "./list.vue?vue&type=template&id=55da6358&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=55da6358&prod&scoped=true&lang=css"
import style1 from "./list.vue?vue&type=style&index=1&id=55da6358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55da6358",
  null
  
)

export default component.exports